<template>
  <div class="vqb-rule" :class="{ 'panel panel-default form-inline': styled }">
    <div :class="{ 'form-group': styled }">
      <v-layout row align-center>
        <label class="pa-3 mb-3 subheading">{{ rule.label }}</label>
        {{ rule.operands }}

        <v-select
          v-if="typeof rule.operands !== 'undefined'"
          :items="rule.operands"
          v-model="query.selectedOperand"
          :class="{ 'form-control': styled }"
          class="pa-2"
        >
        </v-select>

        <v-select
          style="max-width: 300px;"
          v-if="
            typeof rule.operators !== 'undefined' && rule.operators.length > 1
          "
          :return-object="true"
          :items="rule.operators"
          v-model="query.selectedOperator"
          :class="{ 'form-control': styled }"
          class="pa-3"
        >
        </v-select>

        <v-text-field
          :class="{ 'form-control': styled }"
          v-if="rule.inputType === 'text'"
          :disabled="
            query.selectedOperator == 'er tom' ||
              query.selectedOperator == 'er ikke tom' ||
              query.selectedOperator == 'er null' ||
              query.selectedOperator == 'er ikke null'
          "
          type="text"
          v-model="query.value"
          class="pa-3"
          :placeholder="labels.textInputPlaceholder"
        ></v-text-field>
        <v-text-field
          class="pa-3"
          :disabled="
            query.selectedOperator == 'er tom' ||
              query.selectedOperator == 'er ikke tom' ||
              query.selectedOperator == 'er null' ||
              query.selectedOperator == 'er ikke null'
          "
          :class="{ 'form-control': styled }"
          v-if="rule.inputType === 'number'"
          type="number"
          v-model.number="query.value"
          :placeholder="labels.textInputPlaceholder"
        ></v-text-field>
        <v-date-picker
          :disabled="
            query.selectedOperator == 'er tom' ||
              query.selectedOperator == 'er ikke tom' ||
              query.selectedOperator == 'er null' ||
              query.selectedOperator == 'er ikke null'
          "
          :class="{ 'form-control': styled }"
          v-if="rule.inputType === 'date'"
          type="date"
          v-model="query.value"
        ></v-date-picker>

        <template v-if="isCustomComponent">
          <component
            :value="query.value"
            @input="updateQuery"
            :is="rule.component"
          ></component>
        </template>

        <div class="checkbox" v-if="rule.inputType === 'checkbox'">
          <v-checkbox
            :disabled="
              query.selectedOperator == 'er tom' ||
                query.selectedOperator == 'er ikke tom' ||
                query.selectedOperator == 'er null' ||
                query.selectedOperator == 'er ikke null'
            "
            type="checkbox"
            v-for="choice in rule.choices"
            :key="choice.value"
            :label="choice.label"
            :value="choice.value"
            v-model="query.value"
          >
          </v-checkbox>
        </div>

        <div class="radio" v-if="rule.inputType === 'radio'">
          <v-radio-group
            :disabled="
              query.selectedOperator == 'er tom' ||
                query.selectedOperator == 'er ikke tom' ||
                query.selectedOperator == 'er null' ||
                query.selectedOperator == 'er ikke null'
            "
            v-model="radios"
            :mandatory="false"
          >
            <v-radio
              v-for="choice in rule.choices"
              :key="choice.value"
              :label="choice.label"
              :value="choice.value"
            ></v-radio>
          </v-radio-group>
        </div>

        <v-select
          :disabled="
            query.selectedOperator == 'er tom' ||
              query.selectedOperator == 'er ikke tom' ||
              query.selectedOperator == 'er null' ||
              query.selectedOperator == 'er ikke null'
          "
          v-if="
            rule.inputType === 'select' ||
              rule.inputType === 'boolean' ||
              rule.inputType === 'selectNumeric'
          "
          :class="{ 'form-control': styled }"
          class="pa-3"
          :multiple="rule.type === 'multi-select'"
          v-model="query.value"
          :items="rule.choices"
          item-text="label"
          item-value="value"
        >
        </v-select>

        <v-btn
          class="mb-3"
          type="button"
          icon
          :class="{ 'close pull-right': styled }"
          @click="remove"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import deepClone from "./utilities.js";
export default {
  name: "layer-query-builder-rule",
  props: ["query", "index", "rule", "styled", "labels"],
  beforeMount() {
    if (this.rule.type === "custom-component") {
      this.$options.components[this.id] = this.rule.component;
    }
  },
  methods: {
    remove: function() {
      this.$emit("child-deletion-requested", this.index);
    },
    updateQuery(value) {
      let updated_query = deepClone(this.query);
      updated_query.value = value;
      this.$emit("update:query", updated_query);
    },
    reduceRuleChoices: function(groups, item, index) {
      let key = item["group"];
      if (typeof key !== "undefined") {
        groups[key] = groups[key] || [];
        groups[key].push(item);
      } else {
        groups[index] = item;
      }
      return groups;
    }
  },
  computed: {
    isCustomComponent() {
      return this.rule.type === "custom-component";
    },
    selectOptions() {
      if (typeof this.rule.choices === "undefined") {
        return {};
      }
      return this.rule.choices.reduce(this.reduceRuleChoices, {});
    }
  },
  mounted() {
    let updated_query = deepClone(this.query);
    // Set a default value for these types if one isn't provided already
    if (this.query.value === null) {
      if (this.rule.inputType === "checkbox") {
        updated_query.value = [];
      }
      if (this.rule.type === "select") {
        updated_query.value = this.rule.choices[0].value;
      }
      if (this.rule.type === "custom-component") {
        updated_query.value = null;
        if (typeof this.rule.default !== "undefined") {
          updated_query.value = deepClone(this.rule.default);
        }
      }
      this.$emit("update:query", updated_query);
    }
  }
};
</script>
